import * as moment from "moment";

import * as actions from "./actiontypes";
import { SraCustomerUserAction } from "./actions";
import { SraCustomerUser } from "./model";

export function sraCustomerUsers(state: SraCustomerUser[] = [], action: SraCustomerUserAction): SraCustomerUser[] {
    switch (action.type) {
        case actions.LOAD_SRACUSTOMERUSERS_SUCCESS:
            return action.payload.map(c => ({ ...(state.find(s => s.id === c.id) || {}), ...c, listUpdated: moment() }));
        case actions.SAVE_SRACUSTOMERUSER_SUCCESS:
        case actions.LOAD_SRACUSTOMERUSER_DETAIL_SUCCESS:
            if (!state.find(c => c.id === (action.payload.id))) {
                return [ ...state, sraCustomerUser(action.payload, action) ];
            }
            return state.map(c => sraCustomerUser(c, action));
        case actions.CREATE_SRACUSTOMERUSER_SUCCESS:
            return [...state, detailUpdated(action.payload)];
        case actions.DELETE_SRACUSTOMERUSER_SUCCESS:
            return [...state.filter(c => c.id !== action.payload)];
        default:
            return state;
    }
}

function sraCustomerUser(state: SraCustomerUser, action: SraCustomerUserAction): SraCustomerUser {
    switch (action.type) {
        case actions.SAVE_SRACUSTOMERUSER_SUCCESS:
            if (action.payload.id === state.id) {
                return detailUpdated(action.payload, state);
            }
            return state;
        case actions.LOAD_SRACUSTOMERUSER_DETAIL_SUCCESS:
            if (action.payload.id === state.id) {
                return detailUpdated(action.payload, state);
            }
            return state;
        default:
            return state;
    }
}

function detailUpdated(value: SraCustomerUser, state: SraCustomerUser = {} as SraCustomerUser): SraCustomerUser {
    return { listUpdated: moment(), ...state, ...value, detailUpdated: moment() };
}
